<div *ngIf="channelId === 1">
  <app-annuityrates></app-annuityrates>
</div>
<div *ngIf="channelId === 2">
  <app-annuitybankrates></app-annuitybankrates>
</div>
